import { CompositeNode, CompositeOutput } from '../../../types/composite'
import { NODE_CATALOG } from './nodeCatalog'
import { isNodeRef, nodeRefs } from './refs'

/** Assumes nodes are in topological order (the validator enforces it). Unknown refs count 0. */
export const computeNodeWarmups = (nodes: CompositeNode[]): Map<string, number> => {
  const warmups = new Map<string, number>()
  for (const node of nodes) {
    const inputWarmup = nodeRefs(node).reduce(
      // Chart-field refs carry no upstream warm-up — only their own offset
      (max, ref) =>
        Math.max(max, (isNodeRef(ref) ? (warmups.get(ref.node) ?? 0) : 0) + (ref.offset ?? 0)),
      0
    )
    const own = node.kind === 'indicator' ? (NODE_CATALOG[node.name]?.warmup(node.params) ?? 0) : 0
    warmups.set(node.id, own + inputWarmup)
  }
  return warmups
}

export const computeMinCandles = (nodes: CompositeNode[], outputs: CompositeOutput[]): number => {
  const warmups = computeNodeWarmups(nodes)
  return outputs.reduce(
    (max, o) => Math.max(max, (warmups.get(o.ref.node) ?? 0) + (o.ref.offset ?? 0)),
    0
  )
}
